//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LittleHouseItem from '@/components/business/little_house_item'
export default {
    props: {
        recomended_building: Object,
        className: String
    },
    components: {
        LittleHouseItem
    },
    methods: {
        goLink (e) {
            this.$emit('sendLog')
            const { href } = e.currentTarget.dataset
            wx.navigateTo({
                url: href
            })
        }
    }
}
